import { render } from "./ModalVerCobrancasApp.vue?vue&type=template&id=26640d06"
import script from "./ModalVerCobrancasApp.vue?vue&type=script&lang=js"
export * from "./ModalVerCobrancasApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__